// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterBar-cls1_x0j","cls2":"FilterBar-cls2_FoA FilterBar-cls1_x0j"};